import React, { Component, useState } from 'react';
import Products from './Products';
import Header from './Header';
import Footer from './Footer';
import Client from "shopify-buy";
import {withRouter} from 'react-router';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import {FormattedMessage} from "react-intl";
import axios from "axios";
import ReactHtmlParser from 'react-html-parser';
import { Spinner } from 'reactstrap';

// import {
// //     Spinner,
// //     Button,
// //     Card,
// //     CardHeader,
// //     CardBody,
// //     FormGroup,
// //     Form,
// //     Input,
// //     Container,
// //     Row,
// //     Col
// } from "reactstrap";

export const client = Client.buildClient({
    storefrontAccessToken: '8ca8cb5f4a81756952c5994d52462f2c',
    domain: 'dr-brauwolf.myshopify.com',
});

import {loadStripe} from '@stripe/stripe-js';
import {
    CardElement,
    Elements,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';

// import {getBackendUrl} from "../../function/backend";

function getBackendUrl()
{
    let environment = process.env.NODE_ENV;

    // development
    let backendUrl = "http://localhost:9000/";
    // production
    if(environment == 'production')
        backendUrl = "https://admin.vatia.ch/";
    // test
    else if(environment == 'test')
        backendUrl = "https://admin.vatia.ch/";

    return backendUrl;
}

function getStripeKey()
{
    let environment = process.env.NODE_ENV;

    // note: this is the publishable key, not private key => can be revealed to client

    // development
    let backendUrl = "pk_test_KeAtvEIHv33gHRFnhwpXhc2H";
    // production
    if(environment == 'production')
        backendUrl = "pk_live_g7T4M8nNeH1MRX4ygXMjKIue";
    // test
    else if(environment == 'test')
        backendUrl = "pk_live_g7T4M8nNeH1MRX4ygXMjKIue";

    return backendUrl;
}

const UpdateForm = (props) =>
{
    const stripe = useStripe();
    const elements = useElements();

    const subId = props.subId;
    const customerId = props.customerId;

    var [formRender, setFormRender] = useState();
    var [loader, setLoader] = useState(false);

    async function updateCard({ paymentMethodId })
    {
        console.log("paymentMethodId", paymentMethodId);
        console.log("subscriptionId", subId);

        var body = JSON.stringify({
            subscriptionId: subId,
            customerId: customerId,
            paymentMethodId: paymentMethodId
        });

        var updatedCard = await axios.post(getBackendUrl() + 'vatia/update-card', body, {
            // withCredentials: true,
            headers: {
                'content-type': 'application/json',
            }
        })
            .then(function (response)
            {
                // console.log("response",response)
                return true;
            })
            .catch(function (error)
            {
                console.log("error", error);
                return false;
            });
    }

    function onSubscriptionComplete()
    {
        console.log("subscription complete");
        return true;
    }

    function handleRequiresPaymentMethod()
    {
        console.log("attaching ok, charging failed");
    }

    function handleCustomerActionRequired({
                                              subscription,
                                              invoice,
                                              priceId,
                                              paymentMethodId,
                                              isRetry,
                                          }) {

        console.log("customer action required");
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        setLoader(true);
        setFormRender(null);

        var result = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        }).then((result) =>
        {
            if (result.error)
            {
                return false;
            }
            else
            {

                return updateCard({
                    paymentMethodId: result.paymentMethod.id
                });

            }
        });

        if(result != false)
        {
            setLoader(false);
            setFormRender(<p style={{color:"green"}}>Card has been updated</p>);
        }
        else
        {
            setLoader(false);
            setFormRender(<p style={{color:"red"}}>Card could not be updated</p>);
        }
    };

    return (<div>
    {formRender}{loader ? <div><p style={{color:"orange"}}>Updating Card..</p></div> : null}<form onSubmit={handleSubmit}>
        <CardElement /> <br/>
        <button type="submit" disabled={!stripe}>
            Update Credit Card
        </button>
    </form></div>);
};

const stripePromise = loadStripe(getStripeKey());

class User extends Component {

    constructor() {
        super();

        this.state = {
            isCartOpen: false,
            checkout: { lineItems: [] },
            products: [],
            shop: {},
            heroContent: ''
        };

        this.handleCartClose = this.handleCartClose.bind(this);
        this.addVariantToCart = this.addVariantToCart.bind(this);
        this.updateQuantityInCart = this.updateQuantityInCart.bind(this);
        this.removeLineItemInCart = this.removeLineItemInCart.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleMagicLinkRequest = this.handleMagicLinkRequest.bind(this);
        this.cancelSubscription = this.cancelSubscription.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
    }

    componentWillMount()
    {
        if(!localStorage.getItem('checkoutId'))
        {
            client.checkout.create().then((res) => {
                this.setState({
                    checkout: res,
                });
                // setter
                localStorage.setItem('checkoutId', res.id);
            });
        }
        else
        {
            const checkoutId = localStorage.getItem('checkoutId');
            client.checkout.fetch(checkoutId).then((res) => {

                if(res == null || res.order)
                {
                    localStorage.clear();
                    client.checkout.create().then((res) => {
                        this.setState({
                            checkout: res,
                        });
                        // setter
                        localStorage.setItem('checkoutId', res.id);
                    });

                }
                else {
                    this.setState({
                        checkout: res,
                    });
                }
            });
        }

        client.collection.fetchAllWithProducts().then((collections) => {

            var collectionAlcohol =  collections.filter(c => c.title == "Dr. Brauwolf - Regular")[0].products;
            var collectionNoAlcohol =  collections.filter(c => c.title == "Dr. Brauwolf - Alkoholfrei")[0].products;
            var collectionSpecial =  collections.filter(c => c.title == "Dr. Brauwolf - Beer of the Month")[0].products;
            var collectionShirts =  collections.filter(c => c.title == "Dr. Brauwolf - Sonstiges")[0].products;
            var collectionGiftcard = collections.filter(c => c.title == "Dr. Brauwolf - Geschenkkarte")[0].products;

            var unfilteredProducts = collectionAlcohol.concat(collectionSpecial).concat(collectionNoAlcohol).concat(collectionShirts).concat(collectionGiftcard);
            // var filteredProducts = [];
            // unfilteredProducts.forEach(product => {
            //     if(product.tags != null && product.tags.length > 0) {
            //         var tags = product.tags.map(tag => tag.value);
            //         if (!tags.includes("deactivated")) {
            //             filteredProducts.push(product);
            //         }
            //     }
            // });
            this.setState({
                products: unfilteredProducts,
            });
        });

        client.shop.fetchInfo().then((res) => {
            this.setState({
                shop: res,
            });
        });

        var finalLocale = 'en';
        var locale = require('browser-locale')();
        if(locale == null) {
            //console.log('no locale');
        }
        else {
            var localePrefix = locale.substring(0,2);

            if(localePrefix === 'de' || localePrefix === 'fr' || localePrefix === 'it')
            {
                finalLocale = localePrefix + '-CH';
            }
        }

        const cookies = new Cookies();
        if(!cookies.get('ls_lang'))
        {
            cookies.set('checkout_locale', finalLocale, {path: '/'});
            cookies.set('ls_lang', finalLocale, {path: '/'});
        }
    }

    async componentDidMount()
    {
        var code = this.props.location.search.split("=")[1];
        var subscriptions = await axios.get(getBackendUrl()+'vatia/user/'+code).then(response => {
            return response.data;
        });

        this.setState({subscriptions, name: subscriptions[0].name});
    }

    addVariantToCart(variantId, quantity){

        // Add to Cart Button Effect
        //------------------------------------------------------------------------------
        $('.shop-item').each(function() {

            if(this.id === variantId)
            {
                var animating = false;

                var addToCartBtn = $(this).find('.add-to-cart');

                if(!animating) {
                    //animate if not already animating
                    animating =  true;
                    // resetCustomization(addToCartBtn);
                    addToCartBtn.addClass('is-added').find('path').eq(0).animate({
                        //draw the check icon
                        'stroke-dashoffset':0
                    }, 300, function(){
                        setTimeout(function(){
                            // updateCart();
                            addToCartBtn.removeClass('is-added').find('em').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
                                //wait for the end of the transition to reset the check icon
                                addToCartBtn.find('path').eq(0).css('stroke-dashoffset', '19.79');
                                animating =  false;
                            });

                            if( $('.no-csstransitions').length > 0 ) {
                                // check if browser doesn't support css transitions
                                addToCartBtn.find('path').eq(0).css('stroke-dashoffset', '19.79');
                                animating =  false;
                            }
                        }, 600);
                    });
                }
            }
        });

        this.setState({
            isCartOpen: true,
        });

        const lineItemsToAdd = [{variantId, quantity: parseInt(quantity, 10)}];
        const checkoutId = this.state.checkout.id;

        // console.log("adding variant in home");
        // let count = this.state.checkout.lineItems.map((line_item) => {return line_item.quantity;}).reduce(function(a,b) {return a+b;},0) + quantity;
        // let discountCode = "";
        // if(count == 1)
        // {
        //     //Removes the applied discount from an existing checkout.
        //     client.checkout.removeDiscount(this.state.checkout.id).then(checkout => {
        //         console.log("removed discount");
        //     });
        // }
        // else if(count == 2)
        // {
        //     discountCode = 'DM7A2CR4DFP4';
        // }
        // else if(count == 3)
        // {
        //     discountCode = 'R86XDV0Z6S68';
        // }
        // else if(count == 4)
        // {
        //     discountCode = 'N7GYCT233BEY';
        // }
        // else if(count == 5)
        // {
        //     discountCode = 'D7JYFRYS6GSS';
        // }
        //
        // if(discountCode != "" && this.state.checkout.discountApplications)
        // {
        //     if (this.state.checkout.discountApplications.length == 0 && count > 1)
        //     {
        //         client.checkout.addDiscount(this.state.checkout.id, discountCode).then(checkout =>
        //         {
        //             console.log("added new discount", discountCode);
        //         });
        //     }
        //     else
        //     {
        //         if(this.state.checkout.discountApplications[0] != null && this.state.checkout.discountApplications[0].code != discountCode)
        //         {
        //             client.checkout.addDiscount(this.state.checkout.id, discountCode).then(checkout =>
        //             {
        //                 console.log("added new discount", discountCode);
        //             });
        //         }
        //     }
        // }

        return client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    updateQuantityInCart(lineItemId, quantity) {
        const checkoutId = this.state.checkout.id
        const lineItemsToUpdate = [{id: lineItemId, quantity: parseInt(quantity, 10)}]

        return client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    removeLineItemInCart(lineItemId) {
        const checkoutId = this.state.checkout.id

        return client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    handleCartClose() {
        this.setState({
            isCartOpen: false,
        });
    }

    handleMagicLinkRequest()
    {
        axios.post(getBackendUrl()+'vatia/login/magiclink', {email: this.state.email, vendorname: "Dr. Brauwolf", vendoremail: "info@drbrauwolf.ch"}).then(response => {});
    }

    async handleAddressChange(e, index)
    {
        e.preventDefault();
        this.setState({addressLoader: true})
        var s = this.state.subscriptions[index];

       var data = {
           subscriptionId: s.id,
           firstName: s.name,
           lastName: s.lastname,
           street: s.street,
           plz: s.postcode,
           city: s.city
       }

       var subscriptions = await axios.post(getBackendUrl()+'vatia/change-subscription-address', {data}).then(response => response.data);
       this.setState({subscriptions, addressLoader: false, addressMessage: "Address has been changed."})
    }

    async handleSizeChange(e)
    {
        e.preventDefault();

        var data = {}

        var subscriptions = await axios.post(getBackendUrl()+'vatia/change-subscription-size', {data}).then(response => response.data);
        this.setState({subscriptions, cancelLoader: false})
    }

    async cancelSubscription(subscriptionId)
    {
        this.setState({cancelLoader: true})
        var subscriptions = await axios.post(getBackendUrl()+'vatia/cancel-subscription', {subscriptionId: subscriptionId}).then(response => response.data);
        this.setState({subscriptions, cancelLoader: false})
    }

    handleEmailChange(e) {
        this.setState({ email: e.currentTarget.value });
    }

    handleFirstnameChange = (e, index) => {
        var subscriptions = this.state.subscriptions;
        subscriptions[index].name = e.currentTarget.value;
        this.setState({subscriptions});
    }

    handleLastnameChange = (e, index) => {
        var subscriptions = this.state.subscriptions;
        subscriptions[index].lastname = e.currentTarget.value;
        this.setState({subscriptions});
    }

    handleStreetChange = (e, index) => {
        var subscriptions = this.state.subscriptions;
        subscriptions[index].street = e.currentTarget.value;
        this.setState({subscriptions});
    }

    handlePostcodeChange = (e, index) => {
        var subscriptions = this.state.subscriptions;
        subscriptions[index].postcode = e.currentTarget.value;
        this.setState({subscriptions});
    }

    handleCityChange = (e, index) => {
        var subscriptions = this.state.subscriptions;
        subscriptions[index].city = e.currentTarget.value;
        this.setState({subscriptions});
    }

    render() {

        document.onkeydown = checkKey;

        function checkKey(e) {

            e = e || window.event;

            if (e.keyCode == '38') {
                // up arrow
            }
            else if (e.keyCode == '40') {
                // down arrow
            }
            else if (e.keyCode == '37') {
                // left arrow
                document.querySelector('.owl-prev').click();
            }
            else if (e.keyCode == '39') {
                // right arrow
                document.querySelector('.owl-next').click();
            }

            else if (e.keyCode == '13') {
                document.querySelector('.active').querySelector('.detail').click();
            }

            else if (e.keyCode == '27') {
                document.querySelector('.scroll-to-top-btn').click();
            }

        }

        let pageId = this.props.match.params.id;

        if(this.state.subscriptions)
        {
            var subscriptions = this.state.subscriptions.map((s, index) => {

                var updateForm = <Elements stripe={stripePromise}>
                    <UpdateForm
                        subId={s.id}
                        customerId={s.customerid}
                        // toggleSubLoaderCreate={this.toggleSubLoaderCreate}
                        loaderSubscriptionCreate={this.state.loaderSubscriptionCreate}
                    />
                </Elements>;

                return (<div>
                    <hr/>
                    <p>You have an active subscription for Dr. Brauwolf (Price: {s.price/100} CHF)</p>
                    <hr/>
                    <p>Update Your Card For Your Subscription</p>
                    <div style={{width:400}}>
                        {updateForm}
                    </div>
                    <hr/>
                    <p>Change Address</p>
                    <form onSubmit={(e) => this.handleAddressChange(e, index)}>
                        <input type="hidden" name="index" value={index}/>
                        {/*<table style={{maxWidth:600}}>*/}
                        {/*    <tr>*/}
                                <span style={{display:"inline-block", width:100}}>Firstname</span>
                                <input type="text" name="firstName" value={this.state.subscriptions[index].name} onInput={(e) => this.handleFirstnameChange(e, index)}/><br/>
                            {/*</tr>*/}
                            {/*<tr>*/}
                                <span style={{display:"inline-block", width:100}}>Lastname</span>
                                <input type="text" name="lastName" value={this.state.subscriptions[index].lastname} onInput={(e) => this.handleLastnameChange(e, index)}/><br/>
                            {/*</tr>*/}
                            {/*<tr>*/}
                                <span style={{display:"inline-block", width:100}}>Street</span>
                                <input type="text" name="street" value={this.state.subscriptions[index].street} onInput={(e) => this.handleStreetChange(e, index)}/><br/>
                            {/*</tr>*/}
                            {/*<tr>*/}
                                <span style={{display:"inline-block", width:100}}>Plz</span>
                                <input type="text" name="postalCode" value={this.state.subscriptions[index].postcode} onInput={(e) => this.handlePostcodeChange(e, index)}/><br/>
                            {/*</tr>*/}
                            {/*<tr>*/}
                                <span style={{display:"inline-block", width:100}}>City</span>
                                <input type="text" name="city" value={this.state.subscriptions[index].city} onInput={(e) => this.handleCityChange(e, index)}/><br/><br/>
                            {/*</tr>*/}
                        {/*</table>*/}
                        {this.state.addressLoader ? <p style={{color:"orange"}}>Changing address...</p> : <button>Change</button>}{this.state.addressMessage ? <p>{this.state.addressMessage}</p> : ""}
                    </form>
                    {/*<hr/>*/}
                    {/*<p>Change Your Subscription</p>*/}
                    {/*<button>Change</button>*/}
                    <hr/>
                    <p>Cancel Your Subscription (paid until {s.paiduntil})</p>
                    {this.state.cancelLoader ? <p style={{color:"orange"}}>Cancelling subscription...</p> : <button onClick={() => this.cancelSubscription(s.id)}>Cancel</button>}
                </div>)
            });

            return (
                <div className="App">
                    <Header
                        products={this.state.products}
                        checkout={this.state.checkout}
                        isCartOpen={this.state.isCartOpen}
                        handleCartClose={this.handleCartClose}
                        updateQuantityInCart={this.updateQuantityInCart}
                        removeLineItemInCart={this.removeLineItemInCart}
                    />
                    <section className="container padding-top padding-bottom">
                        <div className="row">
                            <h1>Your Account</h1>
                            <hr/>
                            <h2>Hi {this.state.name}</h2>
                            {subscriptions}
                        </div>
                    </section>
                    <Footer/>
                </div>
            );
        }
        else {
                return (
                    <div className="App">
                        <Header
                            products={this.state.products}
                            checkout={this.state.checkout}
                            isCartOpen={this.state.isCartOpen}
                            handleCartClose={this.handleCartClose}
                            updateQuantityInCart={this.updateQuantityInCart}
                            removeLineItemInCart={this.removeLineItemInCart}
                        />
                        <section className="container padding-top padding-bottom">
                            <div className="row">
                                <h1>Your Account</h1>
                                <hr/>
                                <h2>Hi {this.state.name}</h2>
                                <p>You don't have any subscriptions to Dr. Brauwolf</p>
                            </div>
                        </section>
                        <Footer/>
                    </div>
                )
        }
    }
}

// export default Home;
export default withRouter(User)
